module.exports = __webpack_public_path__ + "img/level_three_hover.4c3df034.png";